import { h, initializeWidgetConfiguration, SgWidget, widgetConfiguration } from '@sgwt-widget/core';
import { ComponentProps, emit, props } from 'skatejs';
import SuperHeader from './components/SuperHeader';
import * as css from './sgwt-super-header.less';
import { INavigateAs, ISgwtSuperHeaderProps, ISgwtSuperHeaderUser, IUserDropdownLink } from './sgwt-super-header.types';
import { sgwtSkateProps } from '../common/SkateJsCustomProp';
import WidgetTracker from '../common/WidgetTracker';
import { BUS_GLOBAL_LANGUAGE } from '../common/bus-topics';

export class SgwtSuperHeader extends SgWidget<ISgwtSuperHeaderProps> {
  public static is = 'sgwt-super-header';

  public static props: ComponentProps<SgwtSuperHeader, ISgwtSuperHeaderProps> = {
    container: props.string,

    language: props.string,
    availableLanguages: props.string,
    i18n: sgwtSkateProps.object,
    mode: props.string,
    hideCurrentLanguage: props.boolean,

    hideServicesLink: props.boolean,
    myServicesLabel: props.string,
    myServicesLink: props.string,
    myServicesIcon: props.string,

    user: sgwtSkateProps.object,
    signOutLink: props.string,
    userDropdownLinks: sgwtSkateProps.object,
    sgConnectSupport: props.string,
    environment: props.string,

    navigateAs: props.boolean,
    navigateAsUser: sgwtSkateProps.object,
    navigateAsList: props.array,

    debug: props.boolean
  };

  // HTML attribute used to update their values dynamically...
  public language: string;
  public navigateAsUser?: object;
  public user: ISgwtSuperHeaderUser | null;
  private currentUser: ISgwtSuperHeaderUser | null;

  constructor() {
    super();
    // Check if the SGWTWidgetConfiguration has been defined, otherwise log a warning...
    // In that case, `widgetConfiguration()` will return the default configuration, so we need to test the real object.
    if (!(window as any).SGWTWidgetConfiguration) {
      widgetConfiguration().warn(
        'The global SGWT Widget was not found (`SGWTWidgetConfiguration` object). ' +
        'It must be defined *before* the import of the widget JavaScript.'
      );
    }
  }

  public connectedCallback() {
    super.connectedCallback();
    this.emitEvent('ready');
  }

  private emitEvent(name: string, detail?: object) {
    emit(this, `${SgwtSuperHeader.is}--${name}`, {
      detail: detail || {}
    });
  }

  public changeLanguage(newLanguage: string) {
    this.language = newLanguage;
    widgetConfiguration().bus.publish(BUS_GLOBAL_LANGUAGE, newLanguage);
    this.emitEvent('language-changed', { language: newLanguage });
  }

  private isEmpty(obj?: object) {
    return !obj || Object.keys(obj).length === 0;
  }

  public setUser(user: ISgwtSuperHeaderUser) {
    this.emitEvent('sign-in', user ? { mail: user.mail } : {});
    this.user = user;
    this.currentUser = user;
    if (this.isEmpty(user) && !this.isEmpty(this.navigateAsUser)) {
      this.stopNavigationAs();
    }
  }

  public signOut() {
    // Stop the navigation as if it was enabled.
    if (!this.isEmpty(this.navigateAsUser)) {
      this.stopNavigationAs();
    }
    if (this.user !== null) {
      this.emitEvent('sign-out');
    }
    this.user = null;
    this.currentUser = null;
  }

  public setNavigateAsUser(user: any) {
    this.emitEvent('navigate-as-select-user', {
      user: user
    });
    this.navigateAsUser = user;
  }

  private onNavigateAsClick() {
    this.emitEvent('navigate-as-menu-click');
  }

  public stopNavigationAs() {
    this.emitEvent('stop-navigation-as', { user: this.navigateAsUser });
    this.navigateAsUser = {};
  }

  renderCallback() {
    const navigateAsConf: INavigateAs = {
      active: this.props.navigateAs,
      asUser: this.props.navigateAsUser,
      list: this.props.navigateAsList,
      onSelectUser: (user: any) => this.setNavigateAsUser(user),
      onMenuClick: () => this.onNavigateAsClick(),
      onStopNavigationAs: () => this.stopNavigationAs()
    };
    if (this.user && !this.props.sgConnectSupport) {
      this.currentUser = this.user;
    }

    return (
      <span>
        <style>{(css as any).toString()}</style>
        <SuperHeader
          container={this.props.container}
          language={this.props.language!.toLowerCase()}
          mode={this.props.mode}
          availableLanguages={this.props.availableLanguages}
          onLanguageChanged={newLanguage => this.changeLanguage(newLanguage)}
          additionalI18n={this.props.i18n}
          hideCurrentLanguage={this.props.hideCurrentLanguage}
          hideServicesLink={this.props.hideServicesLink}
          myServicesLabel={this.props.myServicesLabel}
          myServicesLink={this.props.myServicesLink}
          myServicesIcon={this.props.myServicesIcon}
          sgConnectSupport={this.props.sgConnectSupport}
          user={this.currentUser}
          userDropdownLinks={this.props.userDropdownLinks}
          onUserDropdownLinkClicked={(link: IUserDropdownLink) =>
            this.emitEvent('user-dropdown-link-clicked', { link: link })}
          onConnection={user => this.setUser(user)}
          onSignOut={() => this.signOut()}
          signOutLink={this.props.signOutLink}
          environment={this.props.environment}
          navigateAs={navigateAsConf}
          debug={this.props.debug}
        />
        <WidgetTracker widgetName={SgwtSuperHeader.is} />
      </span>
    );
  }
}

initializeWidgetConfiguration(SgwtSuperHeader, {
  disablejQuerySanityCheck: true,
  neverUseShadowDOM: true
});
customElements.define(SgwtSuperHeader.is, SgwtSuperHeader);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-super-header/sgwt-super-header.tsx